// extracted by mini-css-extract-plugin
export default {"center":"Welcome_center__aqb6L","planetSize":"Welcome_planetSize__lh-se","packetSize":"Welcome_packetSize__WwlVW"};